import { Edit, useGetRecordId, useTranslate } from 'react-admin'
import FormInput from '../invoices/FormInput'
import DraftEditActions from './DraftEditActions'

const DraftEdit = () => {

  const draftId = useGetRecordId()
  const translate = useTranslate()

  return (
    <Edit actions={<DraftEditActions />} title={translate("resources.drafts.name", {smart_count: 1})}>
      <FormInput 
        resource='drafts' 
        draftId={draftId} 
      />
    </Edit>
  )
}

export default DraftEdit